<template>
  <CsvBatchList view-route-name="view-import-csv-list" />
</template>

<script>
import CsvBatchList from '@modules/import-csv-batch/views/list.vue'

export default {
  name: 'CportalCsvBatchList',
  components: { CsvBatchList },
}
</script>
